import { FC } from 'react'
import { TControls } from '../../../features/userInfoForm/types'
import CustomLabel from '../CustomLabel'
import CustomInput from '../CustomInput'
import { maxLengthRule, minLengthRule, requiredRule } from '../../utils/formRules'

type TProps = {
  disabled?: boolean
} & TControls

const FirstName: FC<TProps> = ({ control, disabled }) => (
  <div>
    <CustomLabel label="First Name *"/>
    <CustomInput
      name="firstName"
      control={control}
      disabled={disabled}
      rules={{
        required: requiredRule(),
        minLength: minLengthRule(2),
        maxLength: maxLengthRule(100)
      }}
    />
  </div>
)
export default FirstName
